<div class="wrapper">
    <main class="middle-content">
        <div class="page_title_block">
            <h1 class="page_title">Static Content Management</h1>
        </div>
        <div class="content-section">
            <div class="outer-box">

                <div class="tab-section m-0 row w-100 justify-content-end ">
                    <div class="tab">
                        <button class="tablinks mb-4" [ngClass]="tabView == 'patient' ? 'active': ''"
                            (click)="viewTab('patient')">Patient Content</button>
                        <button class="tablinks" [ngClass]="tabView == 'therapist' ? 'active': ''"
                            (click)="viewTab('therapist')">Therapist Content</button>
                    </div>
                </div>

                <div class="global-table no-radius p0">
                    <div class="tab-content1">
                        <div class="tab-pane1">
                            <div class="table-responsive">
                                <!-- patient type content  -->
                                @if(tabView == 'patient'){
                                <table class="table table-bordered">
                                    <thead>
                                        <tr class="no_wrap_th text-center">
                                            <th class="Sorting-img" id=""> Sr No. </th>
                                            <th class="Sorting-img" id=""> Title </th>
                                            <th class="Sorting-img" id="">Description</th>
                                            <th class="action_td_btn3 Sorting-img" id="">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        @for (item of staticContentData; track item; let i = $index) {
                                        <tr class="text-center">
                                            <td class="content">{{i+1}}</td>
                                            <td class="content">{{item?.title}}</td>
                                            <td class="content">
                                                {{item?.update_des}}
                                            </td>

                                            <td class="text-center">
                                                <button class="btn btn-info ms-2 bt-margin"
                                                    [routerLink]="['/edit-static/'+item?.Type]">
                                                    <em class="fa fa-edit" style="color:white"></em></button>
                                            </td>
                                        </tr>
                                        }
                                        @if(!staticContentData.length){
                                        <tr>
                                            <td class="table-no-record" colspan="4">No Record Found</td>
                                        </tr>
                                        }
                                    </tbody>
                                </table>
                                }

                                <!-- therapist  type content  -->
                                @if(tabView == 'therapist'){
                                <table class="table table-bordered">
                                    <thead>
                                        <tr class="no_wrap_th text-center">
                                            <th class="Sorting-img" id=""> Sr No. </th>
                                            <th class="Sorting-img" id=""> Title </th>
                                            <th class="Sorting-img" id="">Description</th>
                                            <th class="action_td_btn3 Sorting-img" id="">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        @for (item of staticContentData; track item; let i = $index) {
                                        <tr class="text-center">
                                            <td class="content">{{i+1}}</td>
                                            <td class="content">{{item?.title}}</td>
                                            <td class="content">
                                                {{item?.update_des}}
                                            </td>

                                            <td class="text-center">
                                                <button class="btn btn-info ms-2 bt-margin"
                                                    (click)="editContent(item?.Type)">
                                                    <em class="fa fa-edit" style="color:white"></em></button>
                                            </td>
                                        </tr>
                                        }
                                        @if(!staticContentData.length){
                                        <tr>
                                            <td class="table-no-record" colspan="4">No Record Found</td>
                                        </tr>
                                        }
                                    </tbody>
                                </table>
                                }
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>